import { render } from "./FulfilDashboard.vue?vue&type=template&id=7fd29180"
import script from "./FulfilDashboard.vue?vue&type=script&lang=js"
export * from "./FulfilDashboard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\root\\baam\\viribuz\\viribuz-dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__